export default __webpack_public_path__ + "static/media/capture.1745ce59.svg";